import { ContractInputAddress } from '../context/types';

/**
 * Convert intake snake_case address to the camelCase shape proto3 JSON expects
 * on the wire. address_line_2 is omitted when empty so the field stays unset
 * downstream rather than serializing as "".
 */
export const addressInputToProto = (
  a: ContractInputAddress,
): Record<string, string> => {
  const out: Record<string, string> = {
    addressLine1: a.address_line_1,
    locality: a.locality,
    regionCode: a.region_code,
    countryCode: a.country_code,
    postalCode: a.postal_code,
  };
  if (a.address_line_2 != null && a.address_line_2 !== '') {
    out.addressLine2 = a.address_line_2;
  }
  return out;
};
